export const MuiInputBaseStyles = {
    styleOverrides: {
        root: {
            top: '0 !important',
            '& legend': {
                fontSize: '0px !important',
                '& > span': {
                    padding: '0 !important',
                },
            },
        },
    },
};
